rdefine('app/products/components/ProductFormLang',['backbone','text!products/lang.html','app/products/properties/BaseProp'],function(Backbone,template,BaseProp) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'tab-pane fade in',
        bindings:{
            el:{
                tabActive:'model.active'
            },
            'input[name=name]':{
                value:{
                    data:'cform.name',
                    events:'change keyup'
                }
            },
            '.property-place':{
                collection:{
                    col:'properties',
                    view:BaseProp,
                    data:{
                        cform:null,
                        lmodel:null
                    }
                }
            },
            '.property-empty-display':{
                toggle:{
                    data:'model.proplength',
                    processor:function(data) {
                        return !data;
                    }
                }
            },
            '.property-has-display':{
                toggle:{
                    data:'model.proplength'
                }
            },
            '[data-role=tagsinputex]':{
                value:{
                    data:'cform.tags',
                    events:'change'
                }
            }
        },
        handlers:{
            tabActive: {
                get:function($el,val) {
                    if(val) {
                        setTimeout(function(){
                            $el.removeClass("in active").show().addClass("active");
                            setTimeout(function(){
                                $el.addClass("in");
                            },0);
                        },150);
                    }else{
                        $el.removeClass("in");
                        setTimeout(function(){
                            $el.removeClass("active").hide();
                        },150);
                    }
                }
            }
        },
        cform:null,
        properties:null,
        initialize:function(options) {
            this.parent = options.parent;
            this.properties = options.properties;

            this.properties.on("add reset remove",function(){
                this.model.set("proplength",this.properties.length);
            }.bind(this));
            GlobalManager.on("reload-props",function(){
                this.properties.reloadProperties();
            }.bind(this));
            this.model.set("proplength",this.properties.length);
            var lang = this.parent.cform.get("lang");
            this.cform = new Backbone.Ribs.Model((lang && lang[this.model.get("language")])?lang[this.model.get("language")]:{});

            this.bindings['.property-place'].collection.data= {
                cform: this.cform,
                lmodel : options.model,
                product_id:this.parent.cform.get('id')
            };
            this.cform.on("change",function(){
                this.parent.trigger("update-lang",this.model.get("language"),this.cform);
            }.bind(this));
            this.$el.html(Template7.compile(template)({currentlang:window.currentlang}));

            this.$el.find("[data-role=tagsinputex]").tagsinput({
                confirmKeys: [13, 44, 188],
                trimValue: true,
                typeahead: {
                    source: function(query) {
                        console.log("SEARCH ", query);
                        return $.get('/products/tags',{query:query});
                    }
                },
                freeInput: true,
                cancelConfirmKeysOnEmpty: true
            });

            var $taginput = this.$el.find("[data-role=tagsinputex]");
            var $tel = this.$el;

            this.$el.find(".bootstrap-tagsinput input").on("keydown", function(e) {
                if(e.keyCode == 13) {
                    console.log($tel.find(".bootstrap-tagsinput .dropdown-menu").css('display'));
                    if($tel.find(".bootstrap-tagsinput .dropdown-menu").css('display') !== 'block') {
                        var val = $(this).val();
                        $(this).val("").trigger("keydown");
                        $taginput.tagsinput("add", val);
                    }else{
                        var val = $tel.find(".bootstrap-tagsinput .dropdown-menu .active a").text();
                        $(this).val("");

                        $taginput.tagsinput("add", val);
                        $tel.find(".bootstrap-tagsinput .dropdown-menu").remove();
                        $(this).blur();
                        var self = this;
                        _.defer(function(){
                            $(self).focus();
                        });
                    }
                    e.preventDefault();
                    return false;
                }
            });

            this.$el.find("[data-role=tagsinputex]").on("itemAdded",function(){
                var el = this.$el.find(".bootstrap-tagsinput input");
                _.defer(function(){
                    el.val("");
                });

            }.bind(this));


            var cval = this.cform.has("tags") ? this.cform.get("tags").split(",") : [];
            $.each(cval, function(i,tag) {
                if(tag.length) {
                    $taginput.tagsinput('add', tag);
                }
            }.bind(this));

        }
    });
});